import toastr from "toastr";
import { Toastme } from "toastmejs";
import swal from "sweetalert2";
import { _ } from "vue-underscore";

const notification = new Toastme({
  timeout: 5000,
  positionY: "bottom", // top or bottom
  positionX: "right", // right left, center
  distanceY: 20, // Integer value
  distanceX: 20, // Integer value
  zIndex: 1000, // Integer value
  theme: "dark", // default, ligh or  dark (leave empty for "default" theme)
  duplicates: false
});

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: "toast-bottom-right",
  preventDuplicates: true,
  onclick: null,
  showDuration: "300",
  hideDuration: "500",
  timeOut: "2000",
  extendedTimeOut: "2000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut"
};

export default {
  getResponseMessage(response) {
    try {
      switch (response.status) {
        case 400:
          if (!response.data.customMessage) {
            _.each(response.data, info => {
              //toastr.error(info);
              notification.error(info);
            });
          } else {
            //toastr.error(response.data.customMessage);
            notification.error(msg);
          }

          break;
        case 404:
        case 401:
        case 500:
          /* toastr.error(
            response.data.customMessage ?
            response.data.customMessage :
            response.statusText
          ); */
          notification.error(
            response.data.customMessage
              ? response.data.customMessage
              : response.statusText
          );
          break;
        default:
          //toastr.success("ok");
          notification.success("ok");
          break;
      }
    } catch (e) {
      const message = navigator.onLine
        ? "Ocurrio un error interno, favor intente de nuevo más tarde"
        : "Verifique el estado de su conexión a internet";
      //toastr.error(message);
      notification.error(message);
    }
  },
  getMessage(msg, type) {
    //toastr[type](msg);
    notification[type](msg);
  },
  getConfirm(msg, type, title, cancelText = "Cancelar", confirmText = "Confirmar") {
    return swal.fire({
      title: title,
      text: msg,
      type: type,
      showCancelButton: true,
      confirmButtonColor: "#14398A",
      cancelButtonColor: "#d33",
      cancelButtonText: cancelText,
      confirmButtonText: confirmText,
      customContainerClass: "backdrop-swal"
    });
  },
  getDialog(msg, type, title) {
    return swal.fire({
      title: title,
      text: msg,
      type: type,
      showCancelButton: false,
      confirmButtonColor: "#14398A",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
      customContainerClass: "backdrop-swal"
    });
  }
};
